export default __webpack_public_path__ + "static/media/Menuly_DragDrop.edeff622.mp4";